<template>
	<div class="buy-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/buy' }">求购求租</el-breadcrumb-item>
			<el-breadcrumb-item class="path-help">信息详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading" >
			<div class="content">
				<div class="detail" v-if="detail">
					<h1><span>[{{detail.type==0?'求购':'求租'}}]</span?>{{detail.title}}</h1>
					<div class="info">
						<!-- <el-image fit="cover" class="image" :src="$img(detail.thumb)" @error="detail.thumb = defaultGoodsImage" /> -->
						<ul>
							<li>
								<span>信息类别:</span>
								<p>{{detail.type==0?'求购':'求租'}}</p>
							</li>
							<li>
								<span>联系人:</span>
								<p>{{detail.contacts||detail.site.name||'暂无'}}</p>
							</li>
							<li>
								<span>联系方式:</span>
								<p v-if="token">
									{{contacts(detail)}}
<!-- 									{{detail.tel || detail.email || detail.phone || shopInfo.telephone || shopInfo.mobile || shopInfo.email || '暂无'}}
 -->								</p>
								<p v-else>
									请登录查看
								</p>
							</li>
							<li>
								<span>期望价格:</span>
								<p v-if="detail.price>0">{{detail.price}}</p>
								<p v-else>面议</p>
							</li>
							<li>
								<span>采购地区:</span>
								<p>{{detail.area?detail.area.name:'全国'}}</p>
							</li>
							<li>
								<span>采购数量:</span>
								<p>{{detail.number||'面议'}}</p>
							</li>
							<li>
								<span>品牌:</span>
								<p>{{detail.brand||'无'}}</p>
							</li>
							<li>
								<span>交货时间:</span>
								<p>{{detail.delivery_time?detail.delivery_time+'天':'无'}}</p>
							</li>
							<li>
								<span>要求型号:</span>
								<p>{{detail.model_number||'无'}}</p>
							</li>
							<li>
								<span>物料描述:</span>
								<p>{{detail.describe||'无'}}</p>
							</li>
							<li>
								<span>截止时间:</span>
								<p>{{detail.validity_time||'无'}}</p>
							</li>
							<li>
								<span>发布时间:</span>
								<p>{{detail.create_time||'无'}}</p>
							</li>
						</ul>
						<div class="seebox">
							<h3>{{detail.site.site_name}}</h3>
							<div class="con">
								{{detail.site.seo_description}}
							</div>
							<div class="l">
								<span>联系人:</span>
								<p>{{detail.contacts||detail.site.name||'暂无'}}</p>
							</div>
							<el-button type="primary" plain @click="see">询问</el-button>
							
							<div  class="l">
								<!-- 
								<span>联系方式:</span>
								<p v-if="token">
									{{contacts(detail)}}
								</p>
								<p v-else>
									请登录查看
								</p> -->
							</div>
						</div>
					</div>
					<sub-title title="具体需求"></sub-title>
					<div class="account">
						<!-- <span>作者:{{detail.author|| $config.title}}</span> -->
						<!-- <span>分类:
							<router-link :to="`/buy-list-${detail.cat_id}`" >{{detail.category.name||''}}</router-link>
						</span> -->
						<!-- <span>发布时间:{{detail.create_time}}</span> -->
					</div>
					<div class="content" v-html="content()"></div>
				</div>
				
				<!-- <div class="right-column">
					<news-sidebar></news-sidebar>
				</div> -->
			</div>
			<div class="other">
				<!-- <sub-title title="相关设备"></sub-title> -->
				<!-- {{newsList}} -->
				<used-recommend :num="4"></used-recommend>
			</div>
		</div>
	</div>
</template>

<script>
import {
	// newsCat,
	newsList,
	// buyDetail
} from "@/api/cms/news";
import {
	buyDetail
} from "@/api/cms/buy";
import SubTitle from "@/components/SubTitle"
import DescText from "@/components/DescText"
import UsedRecommend from "../used/components/recommend"
import {
	mapGetters
} from "vuex"

export default {
	name: 'buy_detail',
	components: {
		// sidebar,
		SubTitle,
		// list1,
		// newsList1,
		UsedRecommend
	},
	data: () => {
		return {
			id:null,
			loading: true,
			detail:null,
			// newsList:[]
		};
	},
	created() {
		this.id = this.$route.params.pathMatch
		// this.id = this.$route.path.replace('/buy-detail-', '');
		// console.log(1333333333333,this.id);
		this.getDetail();
		// this.getNewsList();
	},
	computed: {
		...mapGetters(["token", "defaultHeadImage",])
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			// console.log(22222);
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			buyDetail({
				id: this.id
			}).then(res => {
				if (res.code == 0) {
					if (res.data) {
						this.loading = false;
						this.detail = res.data;
					} else {
						this.$router.push({ path: '/404' });
					}
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(err.message);
			});
		},
		getNewsList() {
			newsList({
				// id: this.id
				// page:
			}).then(res => {
				if (res.code == 0 && res.data) {
						// this.loading = false;
					this.newsList = res.data.list;
				} else {
					// console.log(333)
					// this.$router.push({ path: '/cms/help' });
				}
			}).catch(err => {
				// this.loading = false;
				this.$message.error(err.message);
			});
		},
		contacts(row){
			let str  = (row.tel || row.phone || row.email || row.site.telephone || row.site.mobile || row.site.email || '')
			if(str){
				return str.substr(0,3)+"****"+str.substr(7);
			}
			return '暂无';
		},
		see(){
			if(this.token){
				let c = this.detail.contacts|| this.detail.site.name || '暂无';
				let str  = (this.detail.tel || this.detail.phone || this.detail.email || this.detail.site.telephone || this.detail.site.mobile || this.detail.site.email || '')
				this.$alert(`联系人:${c},联系方式:${str}`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
				});
			}else{
				this.$alert(`请登录查看`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
					// callback: action => {}
				});
			}
		},
		content(){
			let c = this.detail.content || '';
			c= c.replace(/<img[^>]*>/gi,function(match,capture){
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			// console.log(111,c)
			// newContent = newContent.replace(/\<img[^>]*>/gi, '2222222222222');
//         	newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
//         		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
//         		return match;
//         	});
			
        	c = c.replace(/<br[^>]*\/>/gi, '<br>');
//         	newContent = newContent.replace(/\<img[^>]*>/gi, '');
			// console.log(1211,c)
        	c = c.replace(/<p[^>]*>/gi,'<p>')
			// console.log(133311,c)
			// newContent = newContent.replace(/(<([^>]+)>)/ig, '');
			// c = c.replace(/\s+/g,"");
			// console.log(4111,c)
			return c;
			// ()detail.content
		}
	}
};
</script>
<style lang="scss" scoped>
.buy-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}
	
.news {
	padding-bottom: 20px;
	.content{
		// display: flex;
		// flex-flow: wrap;
		width: 1210px;
		margin-bottom: 20px;
		.detail{
			display: block;
			overflow: hidden;
			h1{
				// text-align: center;
				// line-height: 60px;
				span{
					color: $base-color;
					// padding: 0 10px;
					margin-right: 5px;
				}
			}
			.account{
				// margin:  0 0 0 ;
				text-align: right;
				span{
					margin:0  10px;
				}
			}
			.info{
				background-color: $base-color;//#f8f8f8;
				color:#fff;
				border-top-left-radius: 25px;
				border-bottom-right-radius: 25px;
				
				display: flex;
				flex-wrap: wrap;
				padding: 25px;
				// border: 2px solid $base-color;
				margin:  15px 0;
				.image{
					width: 220px;
					height: 130px;
					margin-top: 25px;
				}
				ul{
					flex: 1;
					li{
						padding: 0 15px;
						display: flex;
						flex-wrap: wrap;
						span{
							width: 150px;
							text-align: justify;
						}
						p{
							flex: 1;
						}
					}
				}
				.seebox{
					width: 300px;
					background-color: #fff;
					color: #000;
					padding: 15px;
					border-top-left-radius: 25px;
					border-bottom-right-radius: 25px;
					.con{
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 7;
						overflow: hidden;
						height: 175px;
					}
					.l{
						display: block;
						display: flex;
						flex-wrap: wrap;
						span{
							width: 70px;
						}
					}
					.el-button{
						float: right;
					}
				}
			}
			.content{
				margin: 15px 0 0 0 ;
				display: block;
				overflow: hidden;
				width: 100%;
			}
			
		}
		
		.other{
			display: block;
		}
		// .right-column{
		// 	// width: 260px;
		// 	flex: 1;
		// 	padding-left: 20px;
		// 	overflow: hidden;
		// }
	}
}
</style>
